import { FC } from 'react'
import { Card, DownloadFile } from '@lmc/ui-kit'
import styled from 'styled-components'
import { Col } from 'antd'
import { Button, Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { reportingConstants } from 'locale/reporting'

type Props = {
  title: string
  desc: string
  onClick?: () => void
}

export const DownloadCard: FC<Props> = ({ title, desc, onClick }) => {
  const { t } = useTranslation(NAMESPACE.REPORTING)

  return (
    <Col xs={24} sm={24} md={24} lg={12} xl={8}>
      <MainContainer>
        <Heading>{title}</Heading>
        <DescText level={1}>{desc}</DescText>
        <ButtonCsv variant="text" onClick={onClick}>
          {t(reportingConstants.DOWNLOAD_CSV)}
          <File>
            <DownloadFile />
          </File>
        </ButtonCsv>
      </MainContainer>
    </Col>
  )
}

const Heading = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  font-size: 24px;
  font-weight: 500;
`

const DescText = styled(Text)`
  text-align: left;
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.color.neutral.color8};
  min-height: 180px;
  padding-top: 16px;
`

const ButtonCsv = styled(Button)`
  margin-left: auto;
  margin-top: 10px;
`
const File = styled.div`
  margin-left: 5px;
`

const MainContainer = styled(Card)`
  background-color: ${({ theme }) => theme.color.neutral.color11};
  border-radius: 20px;
  display: flex;
  text-align: center;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  height: 320px;
  padding: 24px 24px;
  margin-bottom: 24px;
`
